import { render, staticRenderFns } from "./MSI.vue?vue&type=template&id=0a6fc94e&scoped=true"
import script from "./MSI.vue?vue&type=script&lang=js"
export * from "./MSI.vue?vue&type=script&lang=js"
import style0 from "./MSI.vue?vue&type=style&index=0&id=0a6fc94e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6fc94e",
  null
  
)

export default component.exports